import "./scss/index.scss";
import { RichText } from "prismic-reactjs";
import React from "react";
export function BottomBar(_ref) {
  var copyright = _ref.copyright,
      terms = _ref.terms;

  var linkResolver = function linkResolver(doc) {
    return "/".concat(doc.uid);
  };

  return React.createElement("div", {
    className: "bottom-bar"
  }, copyright && React.createElement(RichText, {
    render: copyright
  }), terms && React.createElement(RichText, {
    render: terms,
    linkResolver: linkResolver
  }));
}